import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// const baseUrl = process.env.REACT_APP_API_BASE_URL;
import logo from '../../assets/icon.png'
import { Menu } from "lucide-react";


const Navbar = ({ toggleSidebar, abc, xyz }) => {
  const [coinValue, setCoinValue] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch coin value from API
  useEffect(() => {
    const fetchCoinValue = async () => {
      if (!abc || !xyz) {
        return;
      }

      try {
        setLoading(true);
        
        const response = await fetch("https://api.gamegems.co/web/games/verify", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ abc, xyz }),
        });

        if (!response.ok) throw new Error("Verification failed");

        const data = await response.json();

        if (data.status && data.message === "success") {
          setCoinValue(data.data?.coin || 0);
        }
      } catch (err) {
        console.error("Failed to fetch coin value:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCoinValue();
  }, [abc, xyz]);

  // const navigate = useNavigate();

  // const handleLogout = async () => {

  //   try {
  //     const token = localStorage.getItem("token");
  
  //     if (!token) {
  //       throw new Error("No token found");
  //     }
  
  //     const response = await fetch(`${baseUrl}/auth/logout`, {
  //       method: "GET",
  //       headers: {
  //       "Authorization": `Bearer ${token}`
  //     }
  //     });
  
  //     const result = await response.json();
  
  //     if (result?.status === true) {
  //       alert("Logged out successfully");
  //       localStorage.removeItem("token");
  //       navigate("/");
  //     } else {
  //       console.error("Logout failed:", result.message);
  //     }
  //   } catch (err) {
  //     console.error("Logout Error:", err.message);
  //   }

  // };
  return (
    <div className="bg-gradient shadow-lg py-2 px-2 flex justify-between items-center">
      <button onClick={toggleSidebar} className="pr-2">
        <Menu className="h-6 w-6 text-white" />
      </button>
      <img src={logo} alt="Game Gems" title="Game Gems" className="h-12" />
      <div className="flex-1 flex justify-end">
        <div className="flex items-center bg-gray-700 px-4 py-2 rounded-lg">
          <span className="text-yellow-400 mr-2">💎</span>
          <span className="text-white font-semibold">
              Total Gems: <span className="text-green-400">{coinValue !== null ? Number(coinValue).toFixed(2) : '0.00'}</span>
          </span>
        </div>
      </div>
      {/* <button onClick={handleLogout} className="bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-lg shadow-md">Logout</button> */}
    </div>
  );
};

export default Navbar;